import type { PublicConfig } from '@akpl/shared';
import { createContext, type ReactNode, use } from 'react';

const ConfigContext = createContext<PublicConfig | null>(null);

export function ConfigProvider({ value, children }: { value: PublicConfig; children: ReactNode }) {
  return <ConfigContext value={value}>{children}</ConfigContext>;
}

/** The `/config` payload fetched once at boot (docs/05 §1). */
export function useAppConfig(): PublicConfig {
  const config = use(ConfigContext);
  if (!config) throw new Error('useAppConfig must be used inside <ConfigProvider>');
  return config;
}

/**
 * Phase-1 feature switches (decision 2026-09-08). They live here, not in `/config`, until the
 * `settings` table lands with WP3.1 — then this is the single place to swap for the real
 * values. Both are false: no self-service checkout and no Google/Apple sign-in.
 */
export const SETTINGS = {
  auth: { socialEnabled: false },
  billing: { checkoutEnabled: false },
} as const;
